import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './context/AuthContext';
import { MonthProvider } from './context/MonthContext';
import { RefreshProvider } from './context/RefreshContext';

// Pages
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import DashboardPage from './pages/DashboardPage';
import ReceitasPage from './pages/ReceitasPage';
import DespesasPage from './pages/DespesasPage';
import MetasPage from './pages/MetasPage';
import RelatoriosPage from './pages/RelatoriosPage';
import AjustesPage from './pages/AjustesPage';
import MinhaContaPage from './pages/MinhaContaPage';
import ContatoPage from './pages/ContatoPage';

import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';

// Protected Route Component
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#1B2A4A] border-t-transparent mx-auto mb-4"></div>
          <p className="text-lg font-semibold text-slate-600">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  return (
    <MonthProvider>
      <RefreshProvider>{children}</RefreshProvider>
    </MonthProvider>
  );
}

// Public Route - Redirect if authenticated
function PublicRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#1B2A4A] border-t-transparent mx-auto mb-4"></div>
          <p className="text-lg font-semibold text-slate-600">Carregando...</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/painel" replace />;
  }

  return children;
}

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/auth" element={
        <PublicRoute>
          <AuthPage />
        </PublicRoute>
      } />

      {/* Protected Routes */}
      <Route path="/painel" element={
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      } />
      <Route path="/receitas" element={
        <ProtectedRoute>
          <ReceitasPage />
        </ProtectedRoute>
      } />
      <Route path="/despesas" element={
        <ProtectedRoute>
          <DespesasPage />
        </ProtectedRoute>
      } />
      <Route path="/metas" element={
        <ProtectedRoute>
          <MetasPage />
        </ProtectedRoute>
      } />
      <Route path="/relatorios" element={
        <ProtectedRoute>
          <RelatoriosPage />
        </ProtectedRoute>
      } />
      <Route path="/ajustes" element={
        <ProtectedRoute>
          <AjustesPage />
        </ProtectedRoute>
      } />
      <Route path="/minha-conta" element={
        <ProtectedRoute>
          <MinhaContaPage />
        </ProtectedRoute>
      } />
      <Route path="/contato" element={
        <ProtectedRoute>
          <ContatoPage />
        </ProtectedRoute>
      } />
      {/* Blog */}
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />

      {/* Catch all - redirect to landing */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster 
          position="top-center" 
          toastOptions={{
            style: {
              fontSize: '16px',
              padding: '16px',
              borderRadius: '12px',
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
